const calendarEl = document.getElementById('calendar');
window.calendar = new Calendar(calendarEl, {
    themeSystem: 'bootstrap4',
    plugins: [dayGridPlugin, timeGridPlugin, listPlugin, bootstrapPlugin, interactionPlugin],
    initialView: 'dayGridMonth',
    validRange:{
        start: term[0],
        end: term[1]
    },
    selectable: false,
    locale: 'ko',
    timeZone: 'Asia/Seoul',
    headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,listWeek'
    },
    events: {
        url: '/api/events',
        method: 'GET',
        extraParams: {
            start: term[0],
            end: term[1]
        },
        failure: ()=>{
            console.error('캘린더 데이터 오류!');
        },
        color: '#ff9900',
        textColor: 'black',
    },
    eventMouseEnter: (info) => {
        const {event, el} = info;
        popupEvent(event, el);
    }
})

calendar.render();

function popupEvent(event, el)
{
    const popup = document.querySelector('#event-tpl').content.cloneNode(true);
    const {extendedProps} = event._def;
    for(key in extendedProps) {
        if (popup.querySelector(`.${key}`)) {
            if ( null === extendedProps[key] ) {
                popup.querySelector(`.${key}`).remove();
            } else {
                popup.querySelector(`.${key} span`).textContent = extendedProps[key];

                if ( key === 'to' && extendedProps[key] === extendedProps['from']) {
                    popup.querySelector(`.${key}`).remove();
                }
            }
        }
    }

    el.closest('div').querySelectorAll('.event-popup').forEach(el=>el.remove());

    el.closest('div').appendChild(popup);

    let popupEl = el.closest('div').querySelector('.event-popup');
    popupEl.style.left = `${el.getBoundingClientRect().left}px`;
    popupEl.style.top = `${el.getBoundingClientRect().top + 30}px`;
    popupEl.style.backgroundColor = `white`;
    popupEl.style.padding = `5px 10px`;
    popupEl.style.zIndex = `3000`;
    popupEl.style.width = `300px`;
    popupEl.style.boxShadow = `0 0 4px rgba(0,0,0,.2)`;
    feather.replace();

    popupEl.addEventListener('mouseleave', (e)=>{
        e.preventDefault();
        popupEl.remove();
    })
    popupEl.addEventListener('touchend', e=>{
        e.preventDefault();
        popupEl.remove();
    })
    popupEl.addEventListener('click', e=>{
        e.preventDefault();
        popupEl.remove();
    })

}

function getEvents()
{
    axios.get('/api/events')
        .then(r=>{
            const tg = document.querySelector('#schedules');
            tg.innerHTML = '';
            if ( r.data.length > 0 ) {
                r.data.forEach(event=>{
                    const tpl = document.getElementById('list-event-tpl').content.cloneNode(true);
                    const {subject, from, to, time, place} = event;
                    tpl.querySelector('.subject').textContent = subject;
                    tpl.querySelector('.from').textContent = from;
                    tpl.querySelector('.to').textContent = to;
                    tpl.querySelector('.time').textContent = time;
                    tpl.querySelector('.place').textContent = place;

                    if ( from == to || !to ) {
                        tpl.querySelectorAll('.to, .dash').forEach(el=>el.remove());
                    }

                    if ( null === time ) {
                        tpl.querySelectorAll('.time, i[data-feather="clock"]').forEach(el=>el.remove());
                    }

                    tg.appendChild(tpl);
                })

                feather.replace();
            } else {
                tg.innerHTML = '<p class="text-center leading">예정된 계획이 없습니다.</p>';
            }

        })
        .then(()=>{
            const tpl = document.getElementById('list-event-tpl').content.cloneNode(true);
            tpl.querySelector('.subject').textContent = '연회별 이사 속부모 모임';
            tpl.querySelector('.from').textContent = '분기별로 1회 모임(연 4회 모임 / 부부 모임 or 이사 모임)';
            tpl.querySelectorAll('.to, .dash').forEach(el=>el.remove());
            tpl.querySelectorAll('.time, i[data-feather="clock"]').forEach(el=>el.remove());
            tpl.querySelector('.place').textContent = '연회별 이사 속부모 모임 장소';
            document.querySelector('#schedules').appendChild(tpl);
            feather.replace();
        })
        .catch(err=>{
            console.log(err.response ?? err);
        })
}

document.addEventListener('DOMContentLoaded', ()=>{
    getEvents();
})
